// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@flip/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@flip/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";

export const XngGaTrackAddAccount = (props: any) => {
    if (props.apiResult.successful) {
        const state = props.getState() as xGoogleAnalyticsState;
        if (state.xGoogleAnalytics.createAccountEvent) {
            const dataLayer = getDataLayer();
            if (!dataLayer) {
                return;
            }

            const googleAnalyticsData = {
                event: state.xGoogleAnalytics.createAccountEventName,
                name: `${props.apiParameter.account.firstName} ${props.apiParameter.account.lastName}`,
                affiliation: props.apiParameter.account.companyName,
                city: props.apiParameter.account.bCity,
                state:  props.apiParameter.account.bStateName,
                user:  props.apiParameter.account.email,
                business_type:  props.apiParameter.account.businessType,
                website: props.apiParameter.account.website,
                market_segment: props.apiParameter.account.marketSpace,
                title: props.apiParameter.account.title,
            };

            dataLayer.push(googleAnalyticsData);
        }
    }
};

addToChainAfter(chain, ExecuteOnSuccessCallback, XngGaTrackAddAccount);
